import { useQuery } from "@tanstack/react-query";

// Interfaces
import { ILocationFSProps } from "./interfaces";

// API's
import { getLocationFinancialStatements } from "@/Common/api/location/queries";

export const useLocationFS = (props: Readonly<ILocationFSProps>) => {
	const { locationId = "" } = props;
	const { ...results } = useQuery({
		queryKey: ["locationFS", locationId],
		queryFn: async () => getLocationFinancialStatements(locationId),
		staleTime: Infinity,
		enabled: !!locationId,
	});
	return results;
};
